import { useCallback, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { useEmissorCancelOrder } from './useEmissorCancelOrder';
export function useEmissorCancelOrderFlow(contractId) {
    const { t } = useTranslation();
    const { cancelOrder, isLoading } = useEmissorCancelOrder();
    const [cancelTarget, setCancelTarget] = useState(null);
    const [toast, setToast] = useState(null);
    const openCancelModal = useCallback((order) => {
        setCancelTarget(order);
    }, []);
    const closeCancelModal = useCallback(() => {
        setCancelTarget(null);
    }, []);
    const dismissToast = useCallback(() => {
        setToast(null);
    }, []);
    const confirmCancelOrder = useCallback(async () => {
        if (!contractId || !cancelTarget) {
            return;
        }
        try {
            await cancelOrder({ contractId, orderId: cancelTarget.id });
            setCancelTarget(null);
            setToast({ appearance: 'success', message: t('benefits.orders.cancel.success-toast') });
        }
        catch {
            setCancelTarget(null);
            setToast({ appearance: 'error', message: t('benefits.orders.cancel.error-toast') });
        }
    }, [cancelOrder, cancelTarget, contractId, t]);
    return {
        isCancelModalOpen: cancelTarget !== null,
        isCanceling: isLoading,
        toast,
        openCancelModal,
        closeCancelModal,
        confirmCancelOrder,
        dismissToast,
    };
}
